// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { bulkDeleteCrmObjectsRequestToJson, createCrmObjectRequestToJson, createCrmObjectResponseFromJson, deleteCrmObjectRequestToJson, getMultiCrmObjectRequestToJson, getMultiCrmObjectResponseFromJson, listCrmObjectsRequestToJson, listCrmObjectsResponseFromJson, listFieldOptionsRequestToJson, listFieldOptionsResponseFromJson, listFiltersRequestToJson, listFiltersResponseFromJson, restoreCrmObjectRequestToJson, updateCrmObjectRequestToJson, validateCrmObjectRequestToJson, validateCrmObjectResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createContact(request) {
    const raw = await fetchRpc('crm.v1.CRMService/CreateContact', createCrmObjectRequestToJson(request));
    return createCrmObjectResponseFromJson(raw);
}
export function createContact$(request, options) {
    return defer(() => createContactWithTransport$(getGlobalTransport(), request, options));
}
export function createContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/CreateContact', createCrmObjectRequestToJson(request), options)
        .pipe(map(resp => createCrmObjectResponseFromJson(resp)));
}
export async function updateContact(request) {
    await fetchRpc('crm.v1.CRMService/UpdateContact', updateCrmObjectRequestToJson(request));
}
export function updateContact$(request, options) {
    return defer(() => updateContactWithTransport$(getGlobalTransport(), request, options));
}
export function updateContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/UpdateContact', updateCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiContact(request) {
    const raw = await fetchRpc('crm.v1.CRMService/GetMultiContact', getMultiCrmObjectRequestToJson(request));
    return getMultiCrmObjectResponseFromJson(raw);
}
export function getMultiContact$(request, options) {
    return defer(() => getMultiContactWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/GetMultiContact', getMultiCrmObjectRequestToJson(request), options)
        .pipe(map(resp => getMultiCrmObjectResponseFromJson(resp)));
}
export async function listContacts(request) {
    const raw = await fetchRpc('crm.v1.CRMService/ListContacts', listCrmObjectsRequestToJson(request));
    return listCrmObjectsResponseFromJson(raw);
}
export function listContacts$(request, options) {
    return defer(() => listContactsWithTransport$(getGlobalTransport(), request, options));
}
export function listContactsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/ListContacts', listCrmObjectsRequestToJson(request), options)
        .pipe(map(resp => listCrmObjectsResponseFromJson(resp)));
}
export async function listContactsFilters(request) {
    const raw = await fetchRpc('crm.v1.CRMService/ListContactsFilters', listFiltersRequestToJson(request));
    return listFiltersResponseFromJson(raw);
}
export function listContactsFilters$(request, options) {
    return defer(() => listContactsFiltersWithTransport$(getGlobalTransport(), request, options));
}
export function listContactsFiltersWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/ListContactsFilters', listFiltersRequestToJson(request), options)
        .pipe(map(resp => listFiltersResponseFromJson(resp)));
}
export async function deleteContact(request) {
    await fetchRpc('crm.v1.CRMService/DeleteContact', deleteCrmObjectRequestToJson(request));
}
export function deleteContact$(request, options) {
    return defer(() => deleteContactWithTransport$(getGlobalTransport(), request, options));
}
export function deleteContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/DeleteContact', deleteCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function restoreContact(request) {
    await fetchRpc('crm.v1.CRMService/RestoreContact', restoreCrmObjectRequestToJson(request));
}
export function restoreContact$(request, options) {
    return defer(() => restoreContactWithTransport$(getGlobalTransport(), request, options));
}
export function restoreContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/RestoreContact', restoreCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validateContact(request) {
    const raw = await fetchRpc('crm.v1.CRMService/ValidateContact', validateCrmObjectRequestToJson(request));
    return validateCrmObjectResponseFromJson(raw);
}
export function validateContact$(request, options) {
    return defer(() => validateContactWithTransport$(getGlobalTransport(), request, options));
}
export function validateContactWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/ValidateContact', validateCrmObjectRequestToJson(request), options)
        .pipe(map(resp => validateCrmObjectResponseFromJson(resp)));
}
export async function listContactFieldOptions(request) {
    const raw = await fetchRpc('crm.v1.CRMService/ListContactFieldOptions', listFieldOptionsRequestToJson(request));
    return listFieldOptionsResponseFromJson(raw);
}
export function listContactFieldOptions$(request, options) {
    return defer(() => listContactFieldOptionsWithTransport$(getGlobalTransport(), request, options));
}
export function listContactFieldOptionsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/ListContactFieldOptions', listFieldOptionsRequestToJson(request), options)
        .pipe(map(resp => listFieldOptionsResponseFromJson(resp)));
}
export async function bulkDeleteContacts(request) {
    await fetchRpc('crm.v1.CRMService/BulkDeleteContacts', bulkDeleteCrmObjectsRequestToJson(request));
}
export function bulkDeleteContacts$(request, options) {
    return defer(() => bulkDeleteContactsWithTransport$(getGlobalTransport(), request, options));
}
export function bulkDeleteContactsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMService/BulkDeleteContacts', bulkDeleteCrmObjectsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
